import animation from '@/static/girl-and-pigeon.json';
import { useLottie } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { LottieContainer } from './LottieContainer';
import { motion } from 'motion/react';

const GirlContainer = styled(motion.div)`
  position: absolute;
  bottom: 0px;
  right: -10px;

  ${MEDIA_QUERIES.tablet`
    bottom: -86px;
    right: 150px;
  `}

  ${MEDIA_QUERIES.desktop`
    bottom: -96px;
    right: 170px;
  `}

  @media (min-width: 1200px) {
    right: 135px;
  }

  div > svg {
    display: block !important;
    height: 320px !important;
    min-width: 331px;
    bottom: 0 !important;
    right: 0 !important;
    left: auto !important;

    ${MEDIA_QUERIES.tabletAndDesktop`
      height: 385px !important;
      min-width: 381px;
    `}
  }
`;

export const GirlAndPigion: React.FC = () => {
  const ref = useRef(null);

  const lottie = useLottie(ref, {
    animationData: animation,
    lottieConfig: {
      loop: true,
    },
  });

  useEffect(() => {
    if (lottie) lottie.play();
  }, [lottie]);

  return (
    <GirlContainer animate={{ opacity: [0, 1] }}>
      <LottieContainer ref={ref} />
    </GirlContainer>
  );
};
